import { HttpInterceptorFn, HttpErrorResponse, HttpRequest, HttpHandlerFn, HttpEvent, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, throwError, switchMap, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

import { _ } from '@ngx-translate/core';
import { modaleAvviso } from '../components/modali/modale-avviso/modale-avviso.component';
import { modaleErrore } from '../components/modali/modale-errore/modale-errore.component';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	const modalService = inject(NgbModal);

	return next(req).pipe(
		catchError((error: any) => {
			if (error instanceof HttpErrorResponse) {
				switch (error.status) {
					case 401:
						// Se l'errore avviene su una chiamata di refresh o login, non riprovare
						const isAuthRequest = req.url.includes('/api/public/refresh-token') || req.url.includes('/api/public/login');

						if (authService.isAuthenticated() && !isAuthRequest) {
							return authService.refreshToken().pipe(
								switchMap((newToken: string) => {
									// Clona la richiesta originale con il nuovo token
									const headers = req.headers.set('Authorization', `Bearer ${newToken}`);
									const clonedReq = req.clone({ headers });
									return next(clonedReq);
								}),
								catchError((refreshError) => {
									// Se anche il refresh fallisce, logout
									modaleAvviso(modalService, _('Attenzione'), _('SessioneScadutaError'));
									authService.logout();
									return throwError(() => refreshError);
								}),
							);
						} else if (!isAuthRequest) {
							modaleAvviso(modalService, _('Attenzione'), _('CredentialiErrateError'));
							authService.logout();
						}
						break;
					case 409:
						modaleAvviso(modalService, _('Attenzione'), error.error?.message || error.error || _('ErroreGenerico'));
						break;
					case 403:
						modaleAvviso(modalService, _('Attenzione'), _('AutorizzazioneNegataError'));
						break;
					default:
						modaleErrore(modalService, 'Errore', error.error?.message || error.error, error);
						break;
				}
			}
			return throwError(() => error);
		}),
	);
};
